'use client';
import React from 'react';
import { createContext, useContext } from 'react';

import type { CitOrigin } from '@hub/common/src/types/cit-public-api.d.ts';

export const CitOriginClientContext = createContext<string | null>(null);

export function useCitOriginClient() {
  const context = useContext(CitOriginClientContext) as CitOrigin;
  if (!context) {
    throw new Error('useCitOriginClient must be used within a CitOriginClientProvider');
  }
  return context;
}

export default function CitOriginClientProvider({
  children,
  citOrigin
}: {
  children: React.ReactNode;
  citOrigin: CitOrigin;
}) {
  return (
    <CitOriginClientContext.Provider value={citOrigin}>{children}</CitOriginClientContext.Provider>
  );
}
